// Module
var code = `<div class="modal-dialog modal-lg visualiserTreeExplorer" role="document">
    <div class="modal-content">
        <div class="modal-header">
            <button type="button" class="close" data-bind="click: close" aria-hidden="true">
                <i class="icon-cancel"></i>
            </button>
            <h4 class="modal-title">MapReduce Page Entries</h4>
        </div>
        <div class="modal-body">
            <h3>Aggregation Result</h3>
            <pre id="aggregationResultPreview" data-bind="aceEditor: { code: aggregationResult, fontSize:'14px', lang: 'ace/mode/json', readOnly: true }"></pre>
            <div data-bind="if: hasEntries">
                <hr>
                <h3>Entries&nbsp;<span data-bind="text: '(' + tableItems.length.toLocaleString() + ')'"></span></h3>
                <div style="position: relative; height: 500px">
                    <virtual-grid style="height: 500px" class="resizable flex-window" params="controller: gridController"></virtual-grid>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <div class="text-right">
                <button type="button" class="btn btn-default" data-bind="click: \$root.close">Close</button>
            </div>
        </div>
    </div>
</div>
<div class="tooltip json-preview js-visualizer-tree-tooltip" style="opacity: 0">
</div>
`;
// Exports
export default code;